import React, { Component } from "react";
import "./dropdown.css";

class DropDown extends Component {
  constructor(props) {
    super(props);
    this.change = this.change.bind(this);
    this.state = {};
  }
  change(e) {
    this.props.selected(e.target.value);
  }
  render() {
    return (
      <select
        className="lui-select  lui-select--large school-list"
        onChange={e => this.change(e)}
      >
        {this.props.list.map(data => (
          <option key={data[1]} value={data[1]}>
            {data[0]?data[0]:''}{data[2]?' ('+data[2]+')':''}
          </option>
        ))}
      </select>
    );
  }
}

export default DropDown;
